<template>
  <v-card v-if="!$store.state.auth.user" class="loginCard elevation-0" dark :elevation="0" outlined>
    <v-card-text>
      <img alt="" :src="logo">
      <br>
      <b>CLINICAL ASSESSMENT SYSTEM</b>
      <br><br>
      <span>LOGIN TO UWA SCHOOL OF DENTISTRY</span>
      <v-form ref="form" v-model="valid" lazy-validation @submit="submit">
        <span class="error--text">{{loginError || '&nbsp;'}}</span>
        <v-text-field
          v-model="user.username"
          :rules="usernameRules"
          :counter="8"
          label="Pheme Number"
          required
          @keyup.enter="submit"
          validate-on-blur
        />
        <v-text-field
          v-model="user.password"
          :rules="passwordRules"
          label="Password"
          type="password"
          required
          @keyup.enter="submit"
          validate-on-blur
        />
        <span v-if="caps" class="warning--text">
          <v-icon class="warning--text">far fa-exclamation-triangle</v-icon>
          Warning, Caps-Lock is currently enabled.
        </span>
        <v-btn
          :disabled="!/(^\d{8}$)|(^.+@.+[.].+$)/.test(user.username) || !user.password.trim()"
          @click="submit"
        >
          Login
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      valid: false,
      logo: `${process.env.BASE_URL}img/logo.png`,
      loginError: '',
      user: {
        username: '',
        password: '',
      },
      usernameRules: [
        v => !!v || 'Pheme number is required',
        v => /(^\d{8}$)|(^.+@.+[.].+$)/.test(v) || 'Pheme number must be 8 digits',
      ],
      passwordRules: [
        v => !!v.trim() || 'Password is required',
      ],
      caps: false,
    };
  },
  methods: {
    ...mapActions('auth', { authenticate: 'authenticate' }),
    async submit() {
      if (this.$refs.form.validate()) {
        const { query } = this.$router.currentRoute;
        const strategy = /(^\d{8}$)/.test(this.user.username) ? 'pheme' : 'local';
        try {
          await this.authenticate({
            strategy,
            username: this.user.username,
            password: this.user.password,
          });
          this.user.password = '';
          this.$router.push((query && query.followPath) || '/dashboard');
        } catch (err) {
          this.user.password = '';
          this.loginError = err.message;
          console.error(err);
        }
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', (e) => {
      this.caps = !!e.getModifierState('CapsLock');
    });
  },
};
</script>

<style lang="stylus" scoped>
.loginCard
  max-width: 350px;
  margin: 1rem auto;
  background-color: transparent;
  img
    height: 2em;
    padding-right: 0.5em;
  >>> .v-card__text
    font-size: 16px;
    span
      font-weight: 300;
  >>> label.primary--text
    color: white!important;
  >>> .v-input__slot:after
    border-color: white;
</style>
